const defaultDimensions = [1200, 1200] as [number, number];
const getMegapixels = (dimensions: [number, number]) =>
  (dimensions[0] * dimensions[1]) / 1e6;

export const checkAndResizeImage = async (
  file: File,
  dimensions?: [number, number],
): Promise<Blob> => {
  const maxMegapixels = getMegapixels(dimensions ?? defaultDimensions);
  const img = new Image();
  img.src = URL.createObjectURL(file);

  await new Promise((resolve, reject) => {
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      resolve(null);
    };
    img.onerror = (error) => {
      URL.revokeObjectURL(img.src);
      reject(error);
    };
  });

  const megapixels = (img.width * img.height) / 1e6;

  if (megapixels > maxMegapixels) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      throw new Error("Failed to get canvas context");
    }

    const scaleFactor = Math.sqrt(maxMegapixels / megapixels);
    canvas.width = img.width * scaleFactor;
    canvas.height = img.height * scaleFactor;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, file.type),
    );

    if (!blob) {
      throw new Error("Failed to create blob from canvas");
    }

    return blob;
  }

  return file;
};
